import { FiArrowRight, FiSidebar } from 'react-icons/fi'
import { cn } from '../../@/lib/utils'
import { BreadcrumbObjectType } from '../../common/generated/apollo-operations'
import { DossSignalType, useDossSignals } from '../../common/hooks/useDossSignals'
import { useGlobalContext } from '../../common/hooks/useGlobalContext'
import { usePage } from '../../common/hooks/usePage'
import { WorkspaceIcon } from './WorkspaceIcon'

export function TitleBarExpandIcon({
  icon,
  objectType,
  isLeftNavExpanded,
  onPeekStart,
  onPeekEnd,
  isPeeking,
}: {
  icon?: React.ReactElement
  objectType?: BreadcrumbObjectType
  isLeftNavExpanded?: boolean
  onPeekStart?: () => void
  onPeekEnd?: () => void
  isPeeking?: boolean
}) {
  const { dispatch } = useDossSignals()
  const { isSharedPath } = usePage()
  const { user } = useGlobalContext()

  if (!user && isSharedPath) {
    return null
  }

  if (!isLeftNavExpanded || isPeeking) {
    return (
      <div onMouseEnter={onPeekStart} onMouseLeave={onPeekEnd}>
        <div
          className={cn(
            `group/collapse relative h-6 w-6 cursor-pointer items-center justify-center rounded transition duration-300 hover:bg-gray-1`,
            isPeeking ? 'flex' : 'hidden group-hover:flex',
          )}
          onClick={(e) => {
            e.preventDefault()
            onPeekEnd?.() // Stop peeking when clicking to expand
            dispatch(DossSignalType.EXPAND_LEFT_NAV_CLICKED)
          }}
        >
          <FiSidebar size={16} />
          <FiArrowRight className="absolute end-[5px] hidden group-hover/collapse:flex" size={10} />
        </div>
        <div
          className={cn(
            'hover:bg-gray-1 relative flex size-6 cursor-pointer items-center justify-center rounded transition duration-300',
            isPeeking ? 'hidden' : 'group-hover:hidden',
          )}
        >
          <WorkspaceIcon icon={icon} size={16} workspaceType={objectType} />
        </div>
      </div>
    )
  }

  return <WorkspaceIcon icon={icon} size={16} workspaceType={objectType} />
}
